import {swalError, swalSuccessNoButton, getCookie} from "./core";
import Swal from "sweetalert2";
import i18next from "i18next";
import Backend from "i18next-http-backend";
import usersLocale from "./i18n/users.json";

class UserPanel {
    // Constructor
    constructor(modal) {
        this.depositsWithdrawalsModal();
        this.storePaymentMethodsModal();
        this.sidebar();
        this.wallet();

        if (modal === 'deposit') {
            $('[data-target="#deposits-withdrawals-modal"][data-view="deposits"]').first().click();
        }

        if (modal === 'withdraw') {
            $('[data-target="#deposits-withdrawals-modal"][data-view="withdrawals"]').first().click();
        }

        if (modal === 'profile') {
            $('[data-wallet="profile-wallet-body"]').click();
        }

        if (modal === 'wallet-documents') {
            $('[data-wallet="wallet-documents"]').click();
        }

        if (modal === 'wallet-bonus') {
            $('[data-wallet="wallet-bonus"]').click();
        }

        if (modal === 'withdrawable-history') {
            $('#withdrawable-balance-history-modal').modal('show');
        }
    }

    static parseCreditMethodIdFromDataSection(attr) {
        const m = String(attr || '').match(/credit-section-(\d+)/);
        return m ? parseInt(m[1], 10) : NaN;
    }

    static parseDebitMethodIdFromDataSection(attr) {
        const m = String(attr || '').match(/debit-section-(\d+)/);
        return m ? parseInt(m[1], 10) : NaN;
    }

    /**
     * ID de método pendiente (validado en servidor); vacío si no aplica.
     */
    static pendingDepositPaymentMethodId() {
        const raw = $('#deposits-withdrawals-modal').attr('data-deposit-tab-method');
        if (raw === undefined || raw === null || String(raw).trim() === '') {
            return null;
        }
        const n = parseInt(String(raw).trim(), 10);
        return Number.isNaN(n) ? null : n;
    }

    static pendingWithdrawPaymentMethodId() {
        const raw = $('#deposits-withdrawals-modal').attr('data-withdraw-tab-method');
        if (raw === undefined || raw === null || String(raw).trim() === '') {
            return null;
        }
        const n = parseInt(String(raw).trim(), 10);
        return Number.isNaN(n) ? null : n;
    }

    static applyDepositTabByPaymentMethodId(rawId) {
        const idNum = parseInt(String(rawId).trim(), 10);
        if (Number.isNaN(idNum)) {
            return false;
        }
        const $modal = $('#deposits-withdrawals-modal');
        const creditClass = `credit-section-${idNum}`;
        const $sections = $modal.find('#sections-deposit .section-transaction-deposit');
        const $targetSection = $sections.filter(function () {
            return $(this).hasClass(creditClass);
        });
        const $tabLinks = $modal.find('#tabs-deposit li a');
        const $targetTab = $tabLinks.filter(function () {
            return UserPanel.parseCreditMethodIdFromDataSection($(this).attr('data-section')) === idNum;
        }).first();
        if (!$targetSection.length || !$targetTab.length) {
            return false;
        }
        $sections.each(function () {
            this.style.setProperty('display', 'none', 'important');
        });
        const el = $targetSection.get(0);
        if (el) {
            el.style.setProperty('display', 'block', 'important');
        }
        $tabLinks.removeClass('active');
        $targetTab.addClass('active');
        return true;
    }

    static applyWithdrawTabByPaymentMethodId(rawId) {
        const idNum = parseInt(String(rawId).trim(), 10);
        if (Number.isNaN(idNum)) {
            return false;
        }
        const $modal = $('#deposits-withdrawals-modal');
        const debitClass = `debit-section-${idNum}`;
        const $sections = $modal.find('#sections-withdrawal .section-transaction-withdrawal');
        const $targetSection = $sections.filter(function () {
            return $(this).hasClass(debitClass);
        });
        const $tabLinks = $modal.find('#tabs-withdrawal li a');
        const $targetTab = $tabLinks.filter(function () {
            return UserPanel.parseDebitMethodIdFromDataSection($(this).attr('data-section')) === idNum;
        }).first();
        if (!$targetSection.length || !$targetTab.length) {
            return false;
        }
        $sections.each(function () {
            this.style.setProperty('display', 'none', 'important');
        });
        const el = $targetSection.get(0);
        if (el) {
            el.style.setProperty('display', 'block', 'important');
        }
        $tabLinks.removeClass('active');
        $targetTab.addClass('active');
        return true;
    }

    /** Tras mostrar la vista de depósitos (siempre después del loader o al reabrir). */
    static syncDepositTabFromFooterDeepLink() {
        const id = UserPanel.pendingDepositPaymentMethodId();
        if (id === null) {
            return;
        }
        const $modal = $('#deposits-withdrawals-modal');
        $modal.find('.wl-loader').hide();
        $modal.find('.withdrawals-view').hide();
        $modal.find('.deposits-view').show();
        $('#wallet-deposits').addClass('ready-loaded');
        $modal.find('.menu-transaction li a').removeClass('active');
        $('#wallet-deposits').addClass('active');
        UserPanel.applyDepositTabByPaymentMethodId(id);
    }

    static syncWithdrawTabFromFooterDeepLink() {
        const id = UserPanel.pendingWithdrawPaymentMethodId();
        if (id === null) {
            return;
        }
        const $modal = $('#deposits-withdrawals-modal');
        $modal.find('.wl-loader').hide();
        $modal.find('.deposits-view').hide();
        $modal.find('.withdrawals-view').show();
        $('#wallet-withdrawals').addClass('ready-loaded');
        $modal.find('.menu-transaction li a').removeClass('active');
        $('#wallet-withdrawals').addClass('active');
        UserPanel.applyWithdrawTabByPaymentMethodId(id);
    }

    static scheduleSyncDepositDeepLink() {
        const delays = [0, 80, 200, 500, 1000, 1450, 1520, 1700, 2100, 2800, 3600];
        delays.forEach((ms) => {
            setTimeout(() => UserPanel.syncDepositTabFromFooterDeepLink(), ms);
        });
    }

    static scheduleSyncWithdrawDeepLink() {
        const delays = [0, 80, 200, 500, 1000, 1450, 1520, 1700, 2100, 2800, 3600];
        delays.forEach((ms) => {
            setTimeout(() => UserPanel.syncWithdrawTabFromFooterDeepLink(), ms);
        });
    }

    // Deposits and withdrawals modal
    depositsWithdrawalsModal() {
        $('[data-toggle="modal"]').click(function (e) {
            const target = $(this).attr('data-target');
            if (target === '#deposits-withdrawals-modal') {
                let view = $(this).data('view');
                $(`#wallet-${view}`).click();
            }
        });

        $('.menu-transaction li a').click(function () {
            $('.menu-transaction li a').removeClass('active');
            $(this).addClass('active')
        });

        $(document).on('click', '.showTutorial', function () {
            $(this).next().slideToggle()
        })

        $('#tabs-deposit.card-header-tabs li a').click(function (e) {
            const section = $(e.currentTarget).data('section');
            $('#sections-deposit .section-transaction-deposit').hide();
            $(`#sections-deposit .section-transaction-deposit${section}`).fadeIn();
            $('#tabs-deposit.card-header-tabs li a').removeClass('active');
            $(e.currentTarget).addClass('active');
        });

        $('#tabs-withdrawal.card-header-tabs li a').click(function (e) {
            const section = $(e.currentTarget).data('section');
            $('#sections-withdrawal .section-transaction-withdrawal').hide();
            $(`#sections-withdrawal .section-transaction-withdrawal${section}`).fadeIn();
            $('#tabs-withdrawal.card-header-tabs li a').removeClass('active');
            $(e.currentTarget).addClass('active');
        });

        $('#wallet-deposits').click(function () {
            $('.withdrawals-view').hide();

            if (UserPanel.pendingDepositPaymentMethodId() !== null) {
                $('.wl-loader').hide();
                $('.deposits-view').show();
                $(this).addClass('ready-loaded');
                UserPanel.scheduleSyncDepositDeepLink();
                return;
            }

            if ($(this).hasClass('ready-loaded')) {
                $('.deposits-view').show();
                UserPanel.scheduleSyncDepositDeepLink();
            } else {
                $('.wl-loader').show();
                $(this).addClass('ready-loaded');

                setTimeout(function () {
                    $('.wl-loader').hide();
                    $('.deposits-view').show();
                    UserPanel.scheduleSyncDepositDeepLink();
                }, 1500)
            }
        });

        $('#wallet-withdrawals').click(function () {
            $('.deposits-view').hide();

            if (UserPanel.pendingWithdrawPaymentMethodId() !== null) {
                $('.wl-loader').hide();
                $('.withdrawals-view').show();
                $(this).addClass('ready-loaded');
                UserPanel.scheduleSyncWithdrawDeepLink();
                return;
            }

            if ($(this).hasClass('ready-loaded')) {
                $('.withdrawals-view').show();
                UserPanel.scheduleSyncWithdrawDeepLink();
            } else {
                $('.wl-loader').show();
                $(this).addClass('ready-loaded');

                setTimeout(function () {
                    $('.wl-loader').hide();
                    $('.withdrawals-view').show();
                    UserPanel.scheduleSyncWithdrawDeepLink();
                }, 1500)
            }
        });

        $('#deposits-withdrawals-modal').on('shown.bs.modal', function () {
            UserPanel.scheduleSyncDepositDeepLink();
            UserPanel.scheduleSyncWithdrawDeepLink();
        });

        $('.show-deposits-form').click(function () {
            let paymentMethod = $(this).data('payment-method');
            $(`.payment-methods-info-${paymentMethod}`).addClass('d-none');
            $(`.deposits-form-${paymentMethod}`).removeClass('d-none');
        });

        $('.show-payment-methods-info').click(function () {
            let paymentMethod = $(this).data('payment-method');
            $(`.deposits-form-${paymentMethod}`).addClass('d-none');
            $(`.payment-methods-info-${paymentMethod}`).removeClass('d-none');
        });

    }

    // Sidebar
    sidebar() {
        $('[data-wallet]').click(function () {
            let section = $(this).data('wallet');
            $('[data-wallet]').removeClass('active');
            $(`[data-wallet="${section}"]`).addClass('active');
            $('.wallet-body .wallet-section-body').hide();
            $(`.wallet-body .wallet-section-body.${section}`).fadeIn();
        });
    }

    // Payment methods modal
    storePaymentMethodsModal() {
        $('#tabs-payment-methods.card-header-tabs li a').click(function () {
            let section = $(this).data('section');
            $('#sections-payment-methods .section-payment-method').hide();
            $(`#sections-payment-methods .section-payment-method${section}`).fadeIn();
            $('#tabs-payment-methods.card-header-tabs li a').removeClass('active');
            $(this).addClass('active');
        });
    }

    // Wallet
    wallet() {
        $(document).on('click', '.modal-exclusive-wallet .modal-body .method-pay .method-option', function () {
            $('.modal-exclusive-wallet .modal-body .method-pay .method-option').removeClass('active');
            $(this).addClass('active');

            $('.modal-exclusive-wallet .modal-body .method-view section').hide();
            $('.modal-exclusive-wallet .modal-body .method-view').find($(this).data('view')).fadeIn();
        });

        $(document).on('click', '.options-amounts .selector-options .btn-amount-option', function () {
            let amount = $(this).data('amount');
            $('.options-amounts .selector-options .btn-amount-option.selected').removeClass('selected');
            $(this).parent().parent().parent().find('#amount-selectors').val(amount);
            $(this).addClass('selected');
        });

        $(document).on('keyup', '.options-amounts #amount-selectors', function () {
            let amount = $(this).val();
            $('.options-amounts .selector-options .btn-amount-option.selected').removeClass('selected');
            $(this).parent().parent().parent().parent().find('[data-amount="' + amount + '"]').click()
        });

        $(document).on('change', '.options-amounts #amount-selectors', function () {
            let amount = $(this).val();
            $('.options-amounts .selector-options .btn-amount-option.selected').removeClass('selected');
            $(this).parent().parent().parent().parent().find('[data-amount="' + amount + '"]').click()
        });

        $(document).on('click', '.mobile-menu', function () {
            $(this).parent().parent().parent().find('.modal-body').find('.method-pay').toggleClass('opened')
        });

        $(document).on('click', '.method-pay.opened', function () {
            $(this).removeClass('opened')
        });

        $(window).on('load', function () {
            $('.modal-exclusive-wallet .modal-body .method-pay .method-option').eq(0).click();
        });
    }

    // Cancel pending withdrawal
    cancelWithdrawal(route) {
        let $button = $('.cancel-withdrawal-btn');

        $button.click(function () {
            let $btn = $(this);
            let transactionId = $btn.data('id');
            let amount = $btn.data('amount');
            let currency = $btn.data('currency');
            let cancelRoute = route || '/betpay/cancel-withdrawal';

            let locale = getCookie('language-js');
            locale = (locale === null || locale === '') ? 'en_US' : locale;

            i18next.use(Backend)
                .init({
                    lng: locale,
                    resources: usersLocale
                });

            Swal.fire({
                title: i18next.t('cancel_withdrawal_title'),
                html: i18next.t('cancel_withdrawal_message') + '<br><strong>' + currency + ' ' + parseFloat(amount).toFixed(2) + '</strong>',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ff7600',
                cancelButtonColor: '#999',
                confirmButtonText: i18next.t('confirm'),
                cancelButtonText: i18next.t('cancel')
            }).then((result) => {
                if (result.value) {
                    $btn.button('loading');
                    $.ajax({
                        url: cancelRoute,
                        type: 'post',
                        data: {
                            transaction_id: transactionId
                        },
                        dataType: 'json'
                    }).done(function (json) {
                        swalSuccessNoButton(json);
                        setTimeout(() => window.location.reload(), 1000);
                    }).fail(function (json) {
                        swalError(json);
                    }).always(function () {
                        $btn.button('reset');
                    });
                }
            });
        });
    }
}

window.UserPanel = UserPanel;
